import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileAlt } from '@fortawesome/free-solid-svg-icons';

import { uploadProductsList, getProductListModel } from '../../app/store/actions/cart';
import CartImportErrors from './CartImportErrors';


class CartImport extends React.Component {
  constructor(props) {
    super(props);

    this.fileInput = React.createRef();

    this.state = {
      fileName: '',
      errors: [],
      errorMessage: false,
    };
  }

  sendFile = async (file) => {
    this.setState({ errors: [] });

    const result = await this.props.uploadProductsList(file);
    this.setState({
      totalAdded: result.totalAdded || 0,
      errors: (result && result.errors) || [],
      errorMessage: true,
    });
  }

  render() {
    const { fileName } = this.state;

    return (
      <div className="container import-container">

        <div className="instructions-cart-import ">
          <span className="title-cart-import">{I18n.t('instructionsImportingProductList').toUpperCase()}</span>
          <ul className="list-cart-import">
            <li>
              <span className="number-cart-import">1</span>
              {I18n.t('importListInstruction1')}
              <button
                type="button"
                onClick={() => this.props.getProductListModel()}
                className="btn-cart-import"
              >
                <FontAwesomeIcon icon={faFileAlt} className="adjust-icon-cart-import" />
                {I18n.t('importListInstruction2')}
              </button>
            </li>
            <li>
              <span className="number-cart-import">2</span>
              {I18n.t('importListInstruction3')}
            </li>
            <li>
              <span className="number-cart-import">3</span>
              {I18n.t('importListInstruction4')}     
              <label
                className="btn-cart-import"
                htmlFor='selecao-arquivo'
              >
                <span style={{ paddingLeft: '6px' }}>
                  <FontAwesomeIcon icon={faFileAlt} className="adjust-icon-cart-import" />
                </span>
                <span style={{ overflow: 'hidden' }}>
                  {(fileName && fileName.replace(/^.*[\\\/]/, '')) || I18n.t('selectFile')}
                </span>
              </label>
              <input
                type="file"
                onChange={text => this.setState({ fileName: text.target.value })}
                ref={this.fileInput}
                id='selecao-arquivo'
                style={{ display: 'none' }}
              />
              {fileName && (
                <button
                  onClick={() => this.sendFile(this.fileInput.current.files[0])}
                  type="button"
                  className="btn-cart-import"
                >
                  {I18n.t('importListInstruction5')}
                </button>
              )}
            </li>
          </ul>
        </div>
        {this.state.errorMessage && (
          <CartImportErrors totalAdded={this.state.totalAdded} errors={this.state.errors} />
        )}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  uploadProductsList: file => dispatch(uploadProductsList(file)),
  getProductListModel: () => dispatch(getProductListModel()),
});

export default connect(null, mapDispatchToProps)(CartImport);
